<template>
  <div class="commitment-table">
    <CommitmentModal
      v-if="selectedCommitment"
      :commitment="selectedCommitment"
      :request="request"
      @closeCommitmentModal="selectedCommitment = null"
    />

    <table v-if="global.screenWidth >= 1008" class="table-desktop">
      <thead>
        <th data-type="numeric">
          Sewist
          <span class="resize-handle"></span>
        </th>
        <th data-type="text-short">
          Commitment #
          <span class="resize-handle"></span>
        </th>
        <th data-type="text-short">
          Commitment Status
          <span class="resize-handle"></span>
        </th>
        <th data-type="text-short">
          Commitment Date
          <span class="resize-handle"></span>
        </th>
        <th data-type="text-short">
          Masks
          <span class="resize-handle"></span>
        </th>
        <th data-type="text-long">
          Caps
          <span class="resize-handle"></span>
        </th>
        <th data-type="text-long">
          Other
          <span class="resize-handle"></span>
        </th>
      </thead>
      <tbody>
        <tr
          v-for="(commitment, index) in items"
          :key="'commitmentTable' + index + commitment.commitmentId"
          @click="selectedCommitment = commitment"
        >
          <td>{{commitment.firstName}}</td>
          <td>{{commitment.commitmentId}}</td>
          <td>{{commitment.commitmentStatus}}</td>
          <td>{{moment(commitment.commitmentTimestamp).format('l')}}</td>
          <td>{{commitment.masks}}</td>
          <td>{{commitment.caps}}</td>
          <td>{{commitment.other}}</td>
        </tr>
      </tbody>
    </table>
    <div v-else class="table-mobile">
      <div
        v-for="(commitment, index) in items"
        :key="'commitmentTable' + index + commitment.commitmentId"
        @click="selectedCommitment = commitment"
      >
        <span>
          <strong>Commitment #:</strong>
          {{commitment.commitmentId}}
        </span>
        <span>
          <strong>Creation Date:</strong>
          {{moment(commitment.commitmentTimestamp).format('l')}}
        </span>
        <span>
          <strong>Status:</strong>
          {{commitment.commitmentStatus}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CommitmentModal from "@/components/global/Accordion/CommitmentModal";
import moment from "moment";
export default {
  name: "CommitmentTable",
  props: {
    items: {
      type: Array,
      required: true,
    },
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedCommitment: null,
    };
  },
  components: {
    CommitmentModal,
  },
  computed: {
    ...mapState(["global"]),
  },
  methods: {
    moment(date) {
      if (date) return moment(date);
      else return moment();
    },
    ...mapActions(["setUserData"]),
  },
};
</script>

<style lang="scss" scoped>
.commitment-table {
  margin-top: 25px;
  width: 100%;
  max-width: 100vw;
  border-top: 1px solid #efefef;
  .table-desktop {
    cursor: pointer;
    grid-template-columns:
      minmax(100px, 1fr)
      minmax(100px, 1.67fr)
      minmax(100px, 1.67fr)
      minmax(100px, 1.67fr)
      minmax(100px, 1.67fr)
      minmax(100px, 1.67fr)
      minmax(100px, 3.33fr);
  }
  .table-mobile {
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #a8a8a8;
      cursor: pointer;
      span {
        font-size: 14px;
        margin: 7px 0 7px 15px;
        strong {
          color: #8b8795;
        }
      }
    }
  }
  table {
    max-width: 100%;
    width: auto;
    flex: 1;
    display: grid;
    border-collapse: collapse;
    /* These are just initial values which are overriden using JavaScript when a column is resized */
  }

  thead,
  tbody,
  tr {
    display: contents;
  }

  th,
  td {
    padding: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  th {
    position: sticky;
    top: 0;
    background: #fff;
    text-align: left;
    font-weight: normal;
    font-size: 14px;
    color: #8b8795;
    position: relative;
  }

  th:last-child {
    border: 0;
  }

  .resize-handle {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0;
    width: 3px;
    cursor: col-resize;
  }

  .resize-handle:hover,
  /* The following selector is needed so the handle is visible during resize even if the mouse isn't over the handle anymore */
  .header--being-resized .resize-handle {
    opacity: 0.5;
  }

  th:hover .resize-handle {
    opacity: 0.3;
  }

  td {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #808080;
  }

  tr:nth-child(odd) td {
    background: #efefefef;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
}
</style>